import React from "react";
import Layout from "../../components/layout/Layout";
import DatePicker from "react-datepicker";
import { useState } from "react";
import { useAttendanceApi } from "../../hooks/useAttendanceApi";
import { EyeIcon } from "@heroicons/react/solid";
import { MdAutoFixHigh } from "react-icons/md";
import spinner from "../../assets/images/spinner.gif";
import Moment from "react-moment";
import BreadCrumbs from "../../components/ui/BreadCrumbs";
import ViewAttendanceDetail from "../attendance/ViewAttendanceDetail";
import RegularizationModal from "../../components/modals/RegularizationModal";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from "../../components/table/Table";
import RoundedContainer from "../../components/containers/RoundedContainer";
import { LuCalendarClock, LuCalendarSync } from "react-icons/lu";
import { Button } from "../../components/ui";

const attendanceShift = {
  present: {
    color: "bg-green-200 text-green-600",
    value: "Present",
  },
  absent: {
    color: "bg-red-200 text-red-600",
    value: "Absent",
  },
  half_day: {
    color: "bg-lime-200 text-black",
    value: "Half Day",
  },
  weekend: {
    color: "bg-cyan-200 text-cyan-600",
    value: "Weekend",
  },
  weekend_full_day: {
    color: "bg-cyan-200 text-cyan-600",
    value: "Weekend",
  },
  on_approved_leave: {
    color: "bg-blue-200 text-blue-600",
    value: "Leave",
  },
  under_process: {
    color: "bg-orange-200 text-orange-600",
    value: "Under Process",
  },
  missed_punch: {
    color: "bg-purple-200 text-purple-600",
    value: "Missed Punch",
  },
};

function UserAttendance() {
  const breadcrumbs = [
    { label: "Attendance", link: "/user-attendance" },
    { label: "My Attendance", link: `` },
  ];

  const [attendanceId, setAttendanceData] = useState("");
  const [isViewAttendanceDrawerShow, setIsViewAttendanceDrawerShow] =
    useState(false);

  const {
    attendanceList,
    isLoading: isFetching,
    filterData,
    handleMonthChange,
    handleSubmitRegularization,
    isSubmitting: isSubmittingRegularization,
    isRegularizationModalOpen,
    selectedAttendanceForRegularization,
    handleOpenRegularizationModal,
    handleCloseRegularizationModal,
    activeTab,
    handleTabChange,
  } = useAttendanceApi();

  const isDataFound = attendanceList.length > 0;

  const handleOpenAttendanceDrawer = (id) => {
    setIsViewAttendanceDrawerShow(true);
    setAttendanceData(id);
  };

  const handleOpenRegularizationIcon = (data) => {
    handleOpenRegularizationModal(data);
  };

  function tConvert(time) {
    if (!time || time === undefined) {
      return (time = "---");
    }
    time = time
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
    if (time.length > 1) {
      // If time format correct
      time = time.slice(1); // Remove full string match value
      time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
      time.splice(3, 1);
    }
    return time.join(""); // return adjusted time or original string
  }

  return (
    <>
      <div className="px-4 py-4 mb-20">
        <BreadCrumbs crumbs={breadcrumbs} />
        <RoundedContainer className="flex space-x-4 items-end">
          <label className="roboto mb-1 block font-medium">
            Select Month/Year
          </label>
          <div className="basis-[20%]">
            <DatePicker
              required
              name="month_and_year"
              autoComplete="false"
              className="input"
              dateFormat="MM/yyyy"
              showMonthYearPicker
              selected={filterData?.month_and_year}
              onChange={(value) => handleMonthChange(value)}
            />
          </div>
        </RoundedContainer>
        {isFetching ? (
          <div className="w-12 h-12 mx-auto mt-12">
            <img src={spinner} alt="spinner" className="w-full h-full" />
          </div>
        ) : (
          <div className="max-w-full overflow-x-auto">
            <RoundedContainer>
              <Table className="table-auto w-full">
                <TableHead>
                  <TableHeaderCell className="w-1/6 min-w-[10px] font-semibold">
                    Sr.No
                  </TableHeaderCell>
                  <TableHeaderCell className="w-1/6 min-w-[100px] font-semibold">
                    Date
                  </TableHeaderCell>
                  <TableHeaderCell className="w-1/6 min-w-[100px] font-semibold">
                    Day
                  </TableHeaderCell>
                  <TableHeaderCell className="w-1/6 min-w-[100px] font-semibold">
                    In-Time
                  </TableHeaderCell>
                  <TableHeaderCell className="w-1/6 min-w-[100px] font-semibold">
                    Out-Time
                  </TableHeaderCell>
                  <TableHeaderCell className="w-1/6 min-w-[160px] font-semibold">
                    Attendance
                  </TableHeaderCell>
                  <TableHeaderCell className="w-1/6 min-w-[160px] font-semibold">
                    Regularized
                  </TableHeaderCell>
                  <TableHeaderCell className="w-1/6 min-w-[160px] font-semibold text-center">
                    Actions
                  </TableHeaderCell>
                </TableHead>
                {!isDataFound ? (
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={8}>
                        <div className="text-center py-5 text-gray-700 text-3xl font-semibold">
                          No Data found
                        </div>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody>
                    {attendanceList?.map((data, idx) => {
                      const {
                        attendance_date,
                        attendance_month,
                        attendance_year,
                        in_time,
                        out_time,
                        id,
                        date,
                        present_definition,
                        payment_definition,
                        pending_regularization_request,
                      } = data;
                      return (
                        <TableRow key={idx}>
                          <TableCell className="text-dark font-medium text-sm">
                            {idx + 1}
                          </TableCell>
                          <TableCell className="text-dark font-medium text-sm">{`${attendance_date}/${attendance_month}/${attendance_year}`}</TableCell>
                          <TableCell className="text-dark font-medium text-sm">
                            <Moment date={date} format="dddd" />
                          </TableCell>
                          <TableCell className="text-dark font-medium text-sm">
                            {tConvert(in_time)}
                          </TableCell>
                          <TableCell className="text-dark font-medium text-sm">
                            {tConvert(out_time)}
                          </TableCell>
                          <TableCell className="text-dark font-medium text-sm">
                            <span
                              className={`${attendanceShift[present_definition]?.color} px-4 py-1 rounded-full text-sm`}
                            >
                              {attendanceShift[present_definition]?.value}
                            </span>
                          </TableCell>
                          <TableCell className="text-dark font-medium text-sm">
                            <span
                              className={`${attendanceShift[payment_definition]?.color} px-4 py-1 rounded-full text-sm`}
                            >
                              {attendanceShift[payment_definition]?.value}
                            </span>
                          </TableCell>
                          <TableCell className="text-dark font-medium text-sm">
                            <div className="flex items-center justify-center space-x-2">
                              <Button
                                size="icon"
                                variant="ghost"
                                className="cursor-pointer"
                                onClick={() =>
                                  handleOpenRegularizationIcon(data)
                                }
                              >
                                {pending_regularization_request ? (
                                  <LuCalendarClock className="text-yellow-500 hover:text-yellow-600 w-5 h-5" />
                                ) : (
                                  <LuCalendarSync className="text-gray-500 hover:text-gray-600 w-5 h-5" />
                                )}
                              </Button>
                              <Button
                                size="icon"
                                variant="ghost"
                                className="cursor-pointer"
                                onClick={() => handleOpenAttendanceDrawer(id)}
                              >
                                <EyeIcon className="text-gray-600 hover:text-blue-500 w-5 h-5" />
                              </Button>
                            </div>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                )}
              </Table>
            </RoundedContainer>
          </div>
        )}
      </div>
      <ViewAttendanceDetail
        id={attendanceId}
        onClose={() => setIsViewAttendanceDrawerShow(false)}
        open={isViewAttendanceDrawerShow}
      />
      {selectedAttendanceForRegularization && (
        <RegularizationModal
          isOpen={isRegularizationModalOpen}
          onClose={handleCloseRegularizationModal}
          attendanceData={selectedAttendanceForRegularization}
          onSubmit={handleSubmitRegularization}
          isSubmitting={isSubmittingRegularization}
          activeTab={activeTab}
          onTabChange={handleTabChange}
        />
      )}
    </>
  );
}

export default UserAttendance;
